import React, { useEffect, useRef } from 'react'
import { string } from 'prop-types'

import 'tiny-slider/dist/tiny-slider.css'

let tns

if (typeof window !== 'undefined') {
  tns = require('tiny-slider/src/tiny-slider').tns
}

const HtmlContent = ({ className, html }) => {
  const domRef = useRef(null)

  useEffect(() => {
    if (!tns) return null

    const sliders = []
    const sliderDoms = domRef.current.querySelectorAll('.gallery')

    for (let i = 0; i < sliderDoms.length; i += 1) {
      const slider = tns({
        container: `#gallery-${i + 1}`,
        items: 3,
        gutter: 10,
        slideBy: 'page',
        mouseDrag: true,
        autoplay: true
      })

      sliders.push(slider)
    }

    return () => {
      if (sliders.length > 0) {
        sliders.forEach(slider => {
          slider.destroy()
        })
      }
    }
  }, [html])

  return (
    <>
      <div
        ref={domRef}
        className={className}
        dangerouslySetInnerHTML={
          // eslint-disable-line
          { __html: html }
        }
      />
    </>
  )
}

HtmlContent.propTypes = {
  className: string,
  html: string.isRequired
}

HtmlContent.defaultProps = {
  className: ''
}

export default HtmlContent
